import { Input } from '@/components/ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';

function FilterGroups({ searchTerm, setSearchTerm, dayFilter, setDayFilter }) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
      <div className="flex items-center gap-2 w-full">
        <Input
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="w-full max-w-sm"
          placeholder="Guruh nomi bo‘yicha qidirish..."
        />
        <Select value={dayFilter} onValueChange={(val) => setDayFilter(val)}>
          <SelectTrigger className="w-fit">
            <SelectValue placeholder="Kunlar" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Barchasi</SelectItem>
            <SelectItem value="odd">Toq kunlar</SelectItem>
            <SelectItem value="even">Juft kunlar</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}

export default FilterGroups;
